import React from "react";

const reasons = [
  {
    icon: "fa-microchip",
    title: "AI-Driven Efficiency & Cost Savings",
    desc: "Automates resume parsing, candidate matching, and assessments to reduce hiring time and costs.",
  },
  {
    icon: "fa-search",
    title: "Smarter & More Accurate Hiring",
    desc: "AI-powered candidate selection ensures better job-role fit with skill-matching insights.",
  },
  {
    icon: "fa-users",
    title: "Seamless Collaboration & Scalable Solution",
    desc: "One platform for job management, client tracking, and team coordination to streamline workflows.",
  },
  {
    icon: "fa-chart-line",
    title: "Cost-effective & Scalable Solution",
    desc: "Our journey began with modest origins, characterized by determination and hard work.",
  },
  {
    icon: "fa-hourglass",
    title: "Faster, More Accurate Candidate Selection",
    desc: "Originating as a modest team, we've flourished into a workforce exceeding fifty individuals, propelled by our collective determination for success.",
  },
  {
    icon: "fa-handshake",
    title: "Seamless Client & Team Collaboration",
    desc: "We embarked on our journey with a sole focus on a specific technology stack, but as we progressed, we recognized the need to diversify.",
  },
];

const WhyKnackHire = () => {
  return (
    <div className="elementor-widget-container ">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h2>Why KnackHire</h2>
            </div>
          </div>
        </div>

        <div className="row mt-2">
          {reasons.map((item, idx) => (
            <div className="col-sm-12 col-lg-4 col-xl-4 col-md-4 mt-3" key={idx}>
              <div className="item-knackhire text-center p-4">
                <div className="icon-knackhire mb-3">
                  <i className={`fa ${item.icon} fa-2x`}></i>
                </div>
                <div className="info">
                  <h4 className="knackhire-headings">{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style jsx>{`
      
.why-us > h5 {
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom: 25px;
    display: inline-block;
    position: relative;
    z-index: 1;
    padding-left: 45px;
   
}
p {
    color: #666;
    margin: 0 0 15px;
    text-transform: none;
    font-weight: 400;
    line-height: 26px;
    font-size: 14px;
}
.default-padding.bottom-less {
    
    padding-bottom: 90px;
}
.site-heading {
    margin-bottom: 60px;
    overflow: hidden;
    margin-top: -5px;
}
.site-heading h4 {
    color: #086AD8;
    font-weight: 600;
    text-transform: uppercase;
}
 .item-knackhire {
    padding: 60px 30px;
    padding-top: 30px;
    position: relative;
    z-index: 1;
    border-radius: 5px;
    box-shadow: 0 0 10px #cccccc;
    height: 300px;
   
    
}
.services-area .services-items .item h4 a {
    font-weight: 600;
    color:#00a7ac;
}
h4.knackhire-headings {
    color: #000;
    font-size: 20px;
    margin-top: 20px;
}
h4.pricing-headings {
    color: #00a7ac;
    font-size: 20px;
    margin-top: 20px;
}
.icon-knackhire {
    color: #00a7ac;
    font-size: 45px;
}
.benifit-heading{
    color:#00a7ac;
}    


`}</style>
    </div>
  );
};

export default WhyKnackHire;
